import { Drawer as DrawerBase, type DrawerProps } from "@mui/material";

import { useIsVirtualKeyboardOpen } from "@/hooks/useIsVirtualKeyboardOpen";

type Props = Pick<DrawerProps, "open" | "disableRestoreFocus" | "children"> & {
  onClose?: () => void;
  hasFullHeight?: boolean;
  heightOffset?: number;
  backgroundColor?: string;
};

export function Drawer({
  open,
  children,
  onClose,
  hasFullHeight,
  disableRestoreFocus,
  backgroundColor,
  heightOffset = 0,
}: Props) {
  const heightOffsetWithUnit = `${heightOffset}px`;

  const heightStyle = hasFullHeight
    ? `calc(100dvh - ${heightOffsetWithUnit})`
    : "auto";

  const { isVirtualKeyboardOpen, virtualKeyboardHeight } =
    useIsVirtualKeyboardOpen();

  return (
    <DrawerBase
      anchor="bottom"
      open={open}
      onClose={(e, reason) => {
        // do not allow to close the drawer on backdrop click
        if (reason === "backdropClick") return;
        onClose?.();
      }}
      disableRestoreFocus={disableRestoreFocus}
      sx={{
        "& > .MuiDrawer-paper": {
          height: heightStyle,
          backgroundColor,
          ...(isVirtualKeyboardOpen
            ? { paddingBottom: `${virtualKeyboardHeight}px` }
            : {}),
        },
      }}
    >
      {children}
    </DrawerBase>
  );
}
